<div
  class="bs-toast"
  [class.bs-toast--success]="toastKind === 'success'"
  [class.bs-toast--error]="toastKind === 'error'"
  [class.bs-toast--info]="toastKind === 'info'"
  [class.bs-toast--warning]="toastKind === 'warning'"
  [@flyInOut]="state"
  (click)="tapToast()"
  (mouseenter)="stickAround()"
  (mouseleave)="delayedHideToast()"
>
  <div class="bs-toast__header">
    <span class="bs-toast__icon" aria-hidden="true"></span>
    <strong class="bs-toast__title">{{ displayTitle }}</strong>
    <small class="bs-toast__time">{{ timeLabel }}</small>
    <button
      *ngIf="options.closeButton"
      type="button"
      class="bs-toast__close"
      aria-label="Close"
      (click)="action($event)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div
    class="bs-toast__body"
    *ngIf="message && !options.enableHtml"
    role="alert"
    aria-live="polite"
  >
    {{ message }}
  </div>
  <div
    class="bs-toast__body"
    *ngIf="message && options.enableHtml"
    role="alert"
    aria-live="polite"
    [innerHTML]="message"
  ></div>
</div>
